import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path:"/city/list",
    name: 'city_list',
    component:()=>import("@/views/CityView.vue")
  },
  {
    path:"/login",
    name: 'login',
    component:()=>import("@/views/LoginView.vue")
  },
  {
    path:"/pay/:type",
    name: 'pay',
    component:()=>import("@/views/PayView.vue")
  },
  {
    path:"/pay/success/:type/:order",
    name: 'paySuccess',
    component:()=>import("@/views/SuccessView.vue")
  },
  {
    path:"/order",
    name: 'order',
    component:()=>import("@/views/OrderView.vue")
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to,from,next)=>{
  document.title = to.meta.title ? to.meta.title : '川航生活缴费';
  next();
})

export default router
